import styled, { css } from 'styled-components';

interface InputProps {
  error: boolean;
}

export const Input = styled.input<InputProps>`
  margin-left: 17px;
  margin-right: 5px;
  width: 2.2rem;
  height: 2.2rem;

  background: none;
  border: 2px solid #000;

  // TODO: mudar contorno do input para vermelho se houver erro
  ${(props) => props.error && css``}
`;
